﻿import { CategoriesValues, MicroMClient } from "@mcurros2/microm";
import { IconCubeSend } from "@tabler/icons-react";


export const EnvioQuincenalIcon = IconCubeSend;
export const EnvioQuincenalHelpText = '* Aquí puede ver la lista de envíos por quincena.';

export class catEnvioQuincenal extends CategoriesValues {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "EnvioQuincenal";
        this.def.columns.c_category_id.defaultValue = "EnvioQuincenal";
        this.Title = "Envíos Quincenales";
        this.Icon = EnvioQuincenalIcon;
        this.HelpText = EnvioQuincenalHelpText;
    }
}

